import {StandingsWidgetController} from "../standings-widget.controller";
import {STANDINGS_WIDGET} from "../standings-widget.consts";
import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {StandingsWidgetState} from "../models/standings-widget.state";
import {ACTION_TYPES, COMPONENT_STATES} from "../../../core/consts";
import {runInAction} from "mobx"

export class StandingsWidgetTypeChangeHandler extends ActionHandler {
  type = STANDINGS_WIDGET.ACTION_TYPES.changeType;
  controller: StandingsWidgetController;
  state: StandingsWidgetState;

  static injectables = [...ActionHandler.injectables];

  async action(params) {
    runInAction(() => {
      this.state.selectedTabIndex = params.index;
    })

    if (!params.disableFetch) {
      this.store.setComponentState(COMPONENT_STATES.loading);
      await this.controller.action(ACTION_TYPES.fetch, {isPartialFetch: true});
      this.store.setComponentState(COMPONENT_STATES.loaded);
    }
  }
}
